export type { DescendantsManager, Descendant, DescendantOptions } from './descendant';
export { createDescendantContext } from './use-descendant';
export { createDescendantContext as default } from './use-descendant';
